import { useEffect } from 'react';
import { gtmEventShowQuote } from '../utils/analytics';

export const useTagManager = ({ userData, data }) => {
	useEffect(() => {
		if (!data) {
			return;
		}

		if (userData.step === 2) {
			const consultingPackages = userData.packages.map((packageID) => {
				const consultingPackage = data.consulting_packages.find((item) => item.ID === packageID);
				return consultingPackage.key;
			});
			const { plan, units, paymentInterval } = userData;
			gtmEventShowQuote({ plan, units, consultingPackages, paymentInterval });
		}
	}, [data, userData.step]);
};
